'use client'

import { useRouter } from 'next/navigation'
import { useLocale } from '@/components/LocaleContext'

export default function BackButton() {
  const router = useRouter()
  const { locale } = useLocale()
  const backAriaLabelByLocale: Record<string, string> = {
    en: 'Go back',
    fr: 'Retour',
    ar: 'الرجوع',
  }
  const backAriaLabel = backAriaLabelByLocale[locale] ?? backAriaLabelByLocale.en

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back()
      return
    }

    router.push('/products')
  }

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label={backAriaLabel}
      className="inline-flex h-8 w-8 items-center justify-center rounded-full text-neutral-600 transition-colors hover:bg-neutral-100 hover:text-[#111]"
    >
      <span aria-hidden className="text-lg leading-none">
        ←
      </span>
    </button>
  )
}
